import DatasetTable from './DatasetTable'

export default DatasetTable
